import { useState, useEffect } from 'react';
import { axiosInstance } from '../context/AuthContext';
import { ensureWindowCache } from '../utils/cache';
import { buildProcessedData } from '../utils/cache';

export const useCameraData = (artworkId, type) => {
    const [cameraData, setCameraData] = useState({
      rawData: [],
      loading: true,
      error: null
    });
  
    useEffect(() => {
      let isActive = true;
  
      const fetchCameraData = async () => {
        if (!artworkId) {
          console.log('No artworkId provided');
          return;
        }
  
        const artId = artworkId;
        const storageKey = `camera_data_${artworkId}_${type}`;
        const { cache, promises } = ensureWindowCache();
  
        if (isActive) {
          setCameraData((prev) => ({
            ...prev,
            loading: true,
            error: null
          }));
        }
  
        try {
          const storedData = typeof sessionStorage !== 'undefined' ? sessionStorage.getItem(storageKey) : null;
          const lastFetchTime = typeof sessionStorage !== 'undefined' ? sessionStorage.getItem(`${storageKey}_timestamp`) : null;
          if (!promises[storageKey]) {
            console.log(`Attempting to fetch from: /sessions?artId=${artId}&type=${type}`);
            promises[storageKey] = axiosInstance
              .get(`artworks/${artId}/camera-sessions/${type}`)
              .then((response) => {
                console.log('Response status:', response.status);
                console.log('Received data:', response.data);
                const sessions = response.data.sessions || [];
                const newCameraData = buildProcessedData(sessions);
                
                cache[storageKey] = {
                  data: newCameraData,
                  timestamp: Date.now()
                };
  
                if (typeof sessionStorage !== 'undefined') {
                  sessionStorage.setItem(storageKey, JSON.stringify(newCameraData));
                  sessionStorage.setItem(`${storageKey}_timestamp`, Date.now().toString());
                }
  
                return newCameraData;
              })
              .finally(() => {
                delete promises[storageKey];
              });
          }
  
          const resolvedData = await promises[storageKey];
          if (resolvedData && isActive) {
            setCameraData(resolvedData);
          }
        } catch (fetchError) {
          console.error('Error fetching camera data:', fetchError);
          if (isActive) {
            setCameraData((prev) => ({
              ...prev,
              loading: false,
              error: fetchError.response?.data?.error || fetchError.message || 'Failed to fetch camera data'
            }));
          }
        }
      };
  
      fetchCameraData();
  
      return () => {
        isActive = false;
      };
    }, [artworkId]);
    return cameraData;
  };